import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 32px;
  background: #ffffff;
  border-radius: 8px;

  @media screen and (max-width: 600px) {
    padding: 32px 16px;
  }
`;

export const CheckboxBlock = styled.div`
  position: relative;
  margin: 32px 0;
`;

export const LearnMore = styled.span`
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 12px;
  color: #0e71eb;
  cursor: pointer;
  margin-left: 5px;
`;

export const Text = styled.p`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 12px;
  color: #9292a4;
  margin-top: 25px;
`;

export const InputField = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 24px;
`;

export const Label = styled.label`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 4px;
`;

export const Input = styled.input`
  border: 1px solid #c6c7da;
  border-radius: 4px;
  padding: 8px 16px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  outline: none;
  width: 100%;
`;

export const Error = styled.span`
  position: absolute;
  bottom: 22px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 12px;
  color: #f30f00;
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 32px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;
